import { ChangeDetectionStrategy, Component } from '@angular/core';
import { jkBaseForm, TitlebarComponent } from 'jk-service';
import { HindsightSettingsComponent } from '../components/hindsight-query/hindsight-settings.component';

@Component({
  selector: 'app-utyjb56', standalone: true,
  imports: [TitlebarComponent, HindsightSettingsComponent],
  templateUrl: './utyjb56.component.html', styleUrl: './utyjb56.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Utyjb56Component extends jkBaseForm {
  override _programId = 'utyjb56';
  override async ngAfterViewInit() {
    await super.ngAfterViewInit();
    this.checkAllInit(this);
  }
}
